/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import heroBanner from '../assets/logo.png'
import './portalHome.css'
import { getTopVenues } from '../services/home-services';
import { UserContext } from '../context/userContext';
import { useCookies } from 'react-cookie';

function PortalHome() {
  const { initiateSearchQuery } = useContext(UserContext);
  const [searchPostcode, setSearchPostcode] = useState("")
  const [venueData, setVenueData] = useState([])
  const [loading, setLoading] = useState(true)
  const [cookie, setCookie, removeCookie] = useCookies(['whatsonwhere'], "/");

  useEffect(() => {
    const getIpAndVenues = async () => {
   
    }
    getIpAndVenues();
  }, [])

  return (
      <Container classNmae='justify-content-md-center' style={{height:"100vh",color:"white", backgroundColor:"#091440", backgroundPosition:"top"}} fluid>
            <Row className='mb-3 justify-content-md-center' style={{height:"90vh", paddingTop:10, paddingBottom:10,backgroundImage: "url(" + heroBanner + ")",backgroundPosition:"center", backgroundSize:"contain", backgroundRepeat:"no-repeat"}}>
          </Row>
      </Container>
  );
}

export default PortalHome